import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const getProducts = catchAsync((search: string) => {
  let query = "";
  if (search) {
    query = `?search=${search}`;
  }
  //Todo must remove  the category id after merging the backend
  return axiosInstance.get("salon/products" + query);
});

export const listAllProducts = catchAsync(async (search?: string) => {
  let query = "";
  if (search) {
    query = query + "?search=" + search;
  }
  let url = `salon/products` + query;

  const { data } = await axiosInstance.get(url);
  return data;
});
export const productDetails = catchAsync(
  async (
    categoryId: number,
    productId: number,
    xTranslation: boolean = false
  ) => {
    let url = `salon/product-categories/${categoryId}/products/${productId}`;

    const { data } = await axiosInstance.get(url, {
      headers: {
        "x-translations": xTranslation,
      },
    });
    return data;
  }
);
export const addProduct = catchAsync(
  async (productCategory: number, body: any) => {
    const data = await axiosInstance.post(
      `salon/product-categories/${productCategory}/products`,
      body,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return data;
  }
);

export const editProduct = catchAsync(
  async (productCategory: number, product: number, body: any) => {
    const { data } = await axiosInstance.post(
      `salon/product-categories/${productCategory}/products/${product}?_method=put`,
      body,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return data;
  }
);

export const deleteProduct = catchAsync(
  async (productCategory: number, product: number) => {
    const { data } = await axiosInstance.delete(
      `salon/product-categories/${productCategory}/products/${product}`
    );
    return data;
  }
);

export const listProductCategories = catchAsync(async (params?: object) => {
  const { data } = await axiosInstance.get(`salon/product-categories`, {
    params,
  });
  return data;
});
export const showProductCategory = catchAsync(
  async (categoryId: number, xTranslation?: boolean) => {
    const { data } = await axiosInstance.get(
      `salon/product-categories/${categoryId}`,
      {
        headers: {
          "x-translations": xTranslation,
        },
      }
    );
    return data;
  }
);
export const addProductCategories = catchAsync(async (body: any) => {
  const data = await axiosInstance.post(`salon/product-categories`, body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return data;
});
export const updateProductCategories = catchAsync(
  async (categoryId: number, body: any) => {
    const data = await axiosInstance.put(
      `salon/product-categories/${categoryId}`,
      body
    );

    return data;
  }
);
export const deleteProductCategory = catchAsync(async (categoryId: number) => {
  const { data } = await axiosInstance.delete(
    `salon/product-categories/${categoryId}`
  );
  return data;
});
export const addBrand = catchAsync(async (body: any) => {
  const data = await axiosInstance.post(`salon/brands`, body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return data;
});

export const listBrand = catchAsync(async (params?: object) => {
  const { data } = await axiosInstance.get(`salon/brands`, {
    params,
  });
  return data;
});
export const showBrand = catchAsync(
  async (brandId: number, xTranslation?: boolean) => {
    const { data } = await axiosInstance.get(`salon/brands/${brandId}`, {
      headers: {
        "x-translations": xTranslation,
      },
    });
    return data;
  }
);

export const updateBrand = catchAsync(
  async (brandId: number, body: { name: { en: string; ar: string } }) => {
    const { data } = await axiosInstance.put(`salon/brands/${brandId}`, body);
    return data;
  }
);
export const deleteBrand = catchAsync(async (brandId: number) => {
  const { data } = await axiosInstance.delete(`salon/brands/${brandId}`);
  return data;
});
